import React from 'react';

import _ from 'lodash';

import InputTextField from './InputTextField';
import InputNumberField from './InputNumberField';
import InputDateField from './InputDateField';

class PromoCodeTableRow extends React.Component {
  _onInputChange(inputId) {
    return value => {
      const { onValueChange } = this.props;

      const promoCode = _.cloneDeep(this.props.promoCode);
      promoCode.fields[inputId].value = value;

      onValueChange(promoCode);
    };
  }

  render() {
    const {
      promoCode,
      inputId,
      ident,
      editMode
    } = this.props;

    return (
      <tr>
        <td>
          <InputTextField inputId={`${inputId}--${ident}--text`}
            value={promoCode.fields.text.value}
            onChange={this._onInputChange('text')}
            editMode={editMode}
          />
        </td>
        <td>
          <InputNumberField inputId={`${inputId}--${ident}--use-limit`}
            value={promoCode.fields.use_limit.value}
            onChange={this._onInputChange('use_limit')}
            editMode={editMode}
          />
        </td>
        <td>
          <span>{promoCode.fields.use_count.value}</span>
        </td>
        <td>
          <InputDateField inputId={`${inputId}--${ident}--expires-on`}
            key={`${inputId}--${ident}--${promoCode.fields.expires_on.value}`}
            value={promoCode.fields.expires_on.value}
            onChange={this._onInputChange('expires_on')}
            editMode={editMode}
          />
        </td>
      </tr>
    );
  }
}

export default PromoCodeTableRow;
